import { put, all, takeLatest, call } from "redux-saga/effects";
import { Actions as ChatActions, setUnread } from "./actions";
import { getUnreadCount } from "@src/api/lib/chat";

function* onFetchUnreadCount() {
  try {
    const response = yield call(getUnreadCount);
    yield put(setUnread(response.data.conversations));
  } catch {
    // Left as it was: the next socket event or reconnect asks again
  }
}

export default function* chatWatchers() {
  yield all([takeLatest(ChatActions.FETCH_UNREAD_COUNT, onFetchUnreadCount)]);
}
